export default "img {\n    max-width: 300px;\n    display: block;\n    margin: 0 auto 0 0;\n    width: 100%;\n}"